import Layout from "@/layout";

export const dashboardv2 = {
  path: "/dashboardv2",
  name: "Dashboard",
  component: Layout,
  meta: { title: "Dashboard", icon: "dashboard-v2", tag: 'ic-new-tag', tagWidth: '29px', tagHeight: '12px' },
}

export const maintenance = {
  path: "/maintenance",
  name: "Maintenance",
  component: Layout,
  meta: { title: "Maintenance", icon: "maintenance", tagWidth: '29px', tagHeight: '12px' },
  children: [
    {
      path: "scheduled",
      name: "scheduledMaintenance",
      meta: { title: "Scheduled Maintenance" },
    },
    {
      path: "history",
      name: "historyMaintenance",
      meta: { title: "History Maintenance" }
    },
    {
      path: "*",
      name: "",
      meta: { title: "" },
      hidden: true,
    },
  ]
}

export default [
  {
    path: "/permissionSettings",
    name: "Permission Settings",
    component: Layout,
    hidden: true,
    meta: { title: "Permission Settings", icon: "" },
  },
  {
    path: "/fuel-card",
    name: "Wex Fuel Card",
    component: Layout,
    hidden: true,
    meta: { title: "Wex Fuel Card", icon: "" },
    children: [
      {
        path: "account-integration",
        name: "Account Integration Management",
        meta: { title: "Account Integration Management" },
      }, {
        path: "*",
        name: "",
        hidden: true,
        meta: { title: "" },
      }
    ]
  },
  {
    path: "/dialerSeatsPurchase",
    name: "dialerSeatsPurchase",
    component: Layout,
    hidden: true,
    meta: { title: "dialerSeatsPurchase", icon: "" },
    children: [{
      path: '',
      name: "dialerSeatsPurchasePopup",
      component: () => import(/* webpackChunkName: "self-order" */ "@/views/payment-v3/components/subscription/card-popup"),
    }]
  }, {
    path: "/subscription",
    name: "subscription",
    component: Layout,
    hidden: true,
    meta: { title: "Subscription", icon: "" },
    children: [{
      path: 'command-seats',
      name: "commandCardPopup",
      component: () => import(/* webpackChunkName: "self-order" */ "@/views/payment-v3/components/subscription/card-popup"),
    }]
  },
  {
    path: "/dialerSetting",
    name: "dialerSetting",
    component: Layout,
    hidden: true,
    meta: {title: "dialerSetting", icon: ""},
  },
  {
    path: "/insurance",
    name: "Insurance",
    component: Layout,
    hidden: true,
    meta: { title: "Insurance", icon: "" },
    children: [
      {
        path: "edit",
        name: "Edit Insurance",
        meta: { title: "Edit Insurance" },
      },
      {
        path: "add",
        name: "Add Insurance",
        meta: { title: "Add Insurance" },
      },
    ]
  }

];
